const popupTestIDs = {
  popupRoot: 'popup-root',
  popupHeader: 'popup-header',
  popupDescription: 'popup-description',
  popupDiscard: 'popup-discard-button',
  popupCancel: 'popup-cancel-button',
};

export default popupTestIDs;
